import i18n from "i18next";
import resourcesToBackend from "i18next-resources-to-backend";
import { initReactI18next } from "react-i18next";
import en from "./constants/translations/en.json";

const supportedLngs = [
  "en",
  "ta",
  "te",
  "ml",
  "kn",
  "hi",
  "bn",
  "pa",
  "mr",
  "gu",
  "ur",
  "zh",
  "es",
  "fr",
  "ja",
  "ru",
  "de",
  "it",
  "ko",
  "ar",
];

i18n
  .use(
    resourcesToBackend((lng: string, namespace: string) =>
      import(`./constants/translations/${lng}.json`).then(
        ({ default: resources }) =>
          resources[namespace as keyof typeof resources],
      ),
    ),
  )
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    supportedLngs,
    load: "languageOnly",
    // English stays in the initial bundle. Other languages are split into
    // separate chunks and requested only after i18n.changeLanguage().
    partialBundledLanguages: true,
    resources: {
      en: en,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
    react: {
      // There is no Suspense boundary around the application. While a selected
      // language chunk loads, render using the bundled English fallback instead.
      useSuspense: false,
    },
    // pluralSeparator: "_",
  });

export default i18n;
